<template>
	<div class="wood-sample" :class="{'active' : isActive}">
		<div class="bb-wood-type" @click.prevent="onSelect">
			<div class="uk-flex uk-flex-middle">
                <div class="img-container" :style="imgStyle" alt=""></div>
                <p>{{ finishName }}</p>
            </div>
		</div>
	</div>
</template>

<script>
	export default {
		props : {
			finish : Object,
			selected :  Object
		},
		name : "wood-finish",
		components: {},
		methods : {
			onSelect(){
				this.$emit('select',this.finish);
			}
		},
		computed : {
			finishName(){
				return (this.finish.name == undefined)? "" : this.finish.name;
			},
			finishImage(){
				return (this.finish.image == undefined)? "" : this.finish.image.webPath;
			},
			imgStyle(){
				return `background-image: url(${this.finishImage}/200);`;
			},
			isActive() {
				if(this.selected == null ) return false;
				return this.finish.id == this.selected.id;
			}
		}
	}
</script>